var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16.5C11.25 15.6716 11.9216 15 12.75 15C13.5784 15 14.25 15.6716 14.25 16.5C14.25 17.3284 13.5784 18 12.75 18C11.9216 18 11.25 17.3284 11.25 16.5ZM18 18C18.8284 18 19.5 17.3284 19.5 16.5C19.5 15.6716 18.8284 15 18 15C17.1716 15 16.5 15.6716 16.5 16.5C16.5 17.3284 17.1716 18 18 18ZM23.25 18C24.0784 18 24.75 17.3284 24.75 16.5C24.75 15.6716 24.0784 15 23.25 15C22.4216 15 21.75 15.6716 21.75 16.5C21.75 17.3284 22.4216 18 23.25 18ZM33 7.5V25.5H13.8106L7.5 31.8106L7.49991 25.5H3V7.5H33ZM31.5 9H4.5V24H8.99991L9 28.1894L13.1894 24H31.5V9Z",
    fill: "#A4ABB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.4fc36a1ce9e77e9e4270284b57d9627c.svg";
export { ForwardRef as ReactComponent };